import React from "react"
import { useNavigate } from "react-router-dom"
import { Button, Container, Row, Col } from "reactstrap"
import errorImage from "../assets/images/error.png"
import { useSelector } from "react-redux"

const Unauthorized = () => {
  const navigate = useNavigate()
  document.title = "Unauthorized Access"

  const user = useSelector(state => state.auth.user)

  return (
    <div className="d-flex align-items-center min-vh-100 bg-light">
      <Container>
        <Row className="justify-content-center">
          <Col xl={8} lg={10} className="text-center">
            <div className="py-5">
              <div className="mb-4">
                <img
                  src={errorImage}
                  alt="Unauthorized Access"
                  className="img-fluid"
                  style={{ maxHeight: "200px" }}
                />
              </div>
              <h1 className="display-4 font-weight-bold text-danger mb-3">
                Access Denied
              </h1>
              <p className="lead text-muted mb-4">
                This page is for{" "}
                {user.user_type === "admin" ? "users" : "admins"} only. Please
                log in with a {user.user_type === "admin" ? "user" : "admin"}{" "}
                account to continue.
              </p>
              <div className="d-flex gap-3 justify-content-center">
                <Button
                  color="primary"
                  className="px-4"
                  onClick={() => {
                    navigate(-2)
                  }}
                >
                  <i className="mdi mdi-arrow-left me-1"></i> Go Back
                </Button>
                <Button
                  color="primary"
                  outline
                  className="px-4"
                  onClick={() => {
                    if (user.user_type === "admin" || user.user_type === "staff") {
                      navigate("/dashboard", { replace: true })
                    } else {
                      navigate("/home", { replace: true })
                    }
                  }}
                >
                  <i className="mdi mdi-home me-1"></i> Dashboard
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Unauthorized
